import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '../../lib/cn'

type EmptyStateProps = {
  icon: LucideIcon
  title: string
  description?: string
  action?: ReactNode
  className?: string
}

/** The "nothing here" state. Never leave a list blank — Docs/13 §React. */
export const EmptyState = ({
  icon: Icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) => (
  <div
    className={cn(
      'flex flex-col items-center justify-center rounded-lg border border-dashed border-border bg-card/50 px-6 py-12 text-center',
      className,
    )}
  >
    <span className="mb-4 flex size-12 items-center justify-center rounded-full bg-info-subtle text-info-subtle-foreground">
      <Icon aria-hidden="true" className="size-6" />
    </span>
    <h3 className="type-h4 text-foreground">{title}</h3>
    {description ? (
      <p className="mt-2 max-w-prose type-body text-muted-foreground">{description}</p>
    ) : null}
    {action ? <div className="mt-6">{action}</div> : null}
  </div>
)
